import styled from 'styled-components';

import { Row, Col, Select } from '@useblu/ocean-react';

import {
  spacingStackXs,
  spacingStackMd,
  fontFamilyHighlight,
  colorBrandPrimaryPure,
  colorInterfaceDarkDown,
  fontFamilyBase,
  fontSizeXxs,
  fontWeightRegular,
  fontWeightExtrabold,
  fontSizeSm,
  spacingInlineXs,
  spacingInlineXxs,
} from '@useblu/ocean-tokens/web/tokens';

import { breakpointTo, breakpointFrom, bpMedium } from 'tokens';

interface ISelect {
  $extended: boolean;
}

export const Title = styled.h3`
  font-family: ${fontFamilyHighlight};
  font-weight: ${fontWeightExtrabold};
  color: ${colorBrandPrimaryPure};
  font-size: ${fontSizeSm};
  line-height: 22px;

  @media ${breakpointFrom(bpMedium)} {
    display: none;
  }
`;

export const Container = styled.div`
  width: 100%;
  margin-top: ${spacingStackMd};
`;

export const CustomLabel = styled.p`
  display: flex;
  align-items: center;
  margin: 0px;
  color: ${colorInterfaceDarkDown};
  font-family: ${fontFamilyBase};
  font-size: ${fontSizeXxs};
  font-weight: ${fontWeightRegular};
  line-height: 1.1;
  margin-bottom: ${spacingInlineXxs};

  span {
    margin-left: 5.6px;
  }

  .ods-tooltip {
    height: 18px;
  }
`;

export const CustomRow = styled(Row)`
  &&& {
    margin-bottom: ${spacingStackXs};

    @media ${breakpointTo(bpMedium)} {
      margin-bottom: 0px;
    }
  }
`;

export const CustomCol = styled(Col)`
  &&& {
    @media ${breakpointTo(bpMedium)} {
      margin-bottom: ${spacingInlineXs};
    }

    .ods-select__root {
      min-width: auto;
    }
  }
`;

export const CustomSelect = styled(Select)<ISelect>`
  &&& {
    width: ${props => (props.$extended ? '100%' : '106px')};

    @media ${breakpointTo(bpMedium)} {
      width: 100%;
    }
  }
`;
